import AuthValidation from "../../validation/AuthValidation";
import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class ServerListRequest implements IRequestModel {

    constructor() {
    }

    uri: string = "server/list";
    method: HttpMethod = HttpMethod.GET;

    isValid(): ValidationResponse {
        return ValidationResponse.Success();
    }
}